module.exports = __webpack_public_path__ + "img/Arbs_Logo.0d159dbc.png";